var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStudy = function SvgIconStudy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.333 13.667h5m-5-2.5h5M10.667 2 10.396 2h-3.73c-.933 0-1.4 0-1.756.182-.314.16-.569.414-.728.728C4 3.266 4 3.733 4 4.667v9.667c0 .933 0 1.4.182 1.756.16.314.414.569.728.729.356.181.822.181 1.754.181h6.339c.931 0 1.397 0 1.753-.181.314-.16.57-.415.73-.73.18-.355.18-.821.18-1.753V7m-4.999-5c.238.003.388.012.531.046q.256.062.483.2c.168.103.312.247.6.535l2.605 2.605c.288.288.431.432.535.6q.137.226.2.482c.034.143.043.294.045.532m-4.999-5v2.334c0 .933 0 1.4.181 1.756.16.314.415.569.728.729C11.933 7 12.4 7 13.331 7h2.335"
  })));
};
export default SvgIconStudy;